<template>


<div class="row" v-if="this.$gate.areFirmaSelectata()"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->
    <div class="toolbar py-6">
        <div class="container-fluid d-flex align-items-center">
            <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
                    <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
                        <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a></li>
                        <li class="breadcrumb-item pe-3 text-muted">Lista facturi intrare</li>
                    </ol>
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
            </div>
        </div>
    </div>
		
    <div v-if="!this.$gate.firmaActiva()" class="alert alert-warning text-center my-10">
        <h4 class="mb-2"><i class="fas fa-exclamation-triangle text-warning me-2"></i> Firma nu este activă</h4>
        <p>Nu poți accesa facturile până ce firma nu este validată.</p>
    </div>

    <div class="content d-flex flex-column flex-column-fluid" v-if="this.$gate.firmaActiva()">
        <AdaugaFactura_Intrare
            v-if="afiseazaFormularFactura"
            v-model:afiseazaLista="afiseazaTabel"
            :editMode="editModeFactura"
            :facturaEdit="facturaDeEditat"
            @renuntaFactura="handleRenuntaFactura"
            @facturaSaved="handleFacturaSaved"
        />
        <!-- Facturare Table Card -->
        <div class="container-fluid mb-12" v-if="afiseazaTabel">
            <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                    <div class="card-title">
                        <div class="d-flex align-items-center position-relative my-1">
                            <h3 class="card-title">Lista facturi intrare</h3>
                        </div>
                    </div>
                    <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                        <div class="input-group w-250px">
                            
                        </div>
                        <div class="w-100 mw-150px">
                            
                        </div>
                        <a href="#" class="btn btn-primary" @click="editModeFactura=false; facturaDeEditat=null; afiseazaFormularFactura = true; afiseazaTabel=true;">Adaugă factură de intrare</a>
                        <a href="#" v-if="$gate.isAdmin()" class="btn btn-light-primary me-3" @click="preiaFacturiAnaf">
                            A-PreiaFacturiANF
                        </a>
                        <a href="#" v-if="$gate.isAdmin()" class="btn btn-dark me-2" @click="extrageDateXML()">A-extrageXML</a>
                        <a href="#" class="btn btn-dark me-2" @click="importaDateEFactura()">Importa facturi </a>
                        <a href="#" class="btn btn-warning" @click="descarcaUltimeleFacturi">Descarca ultimele facturi</a>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div id="tabel_facturare_wrapper" class="table table-bordered table-striped">
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped nowrap" role="grid" id="tabel_facturare" >
                                <thead>
                                    <tr class="text-uppercase fw-bold">
                                        <th style="display:none;"></th> <!-- ID (ascuns) -->
                                        <th></th>
                                        <th>Data</th>
                                        <th>Data eF</th>
                                        <th>Nr. doc.</th>
                                        <th>Furnizor</th>
                                        <th>Valoare</th>
                                        <th>TVA</th>
                                        <th>Total</th>
                                        <th>Stare</th>
                                        <th>Sold</th>
                                        <th>Scadenta</th>
                                        <th>e-Fact</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(factura) in facturi_intrare" :key="factura.id">
                                      <tr>
                                        <!-- Coloană ID ascunsă pentru sortare primară (numeric) -->
                                        <td style="display:none;">{{ Number(factura.id) || 0 }}</td>
                                        <td class="details-control text-center" style="cursor: pointer;" @click="toggleFacturaDetails(factura)">
                                          <i class="fas fa-chevron-down" :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                                        </td>
                                        <td>{{ $filters.formatDate(factura.data_doc) || '/' }}</td>
                                        <td>{{ $filters.formatDate(factura.afp_data_creare) || '/' }}</td>
                                        <td :data-order="Number(factura.nr_doc) || 0">
                                            {{ factura.serie_doc }}{{ factura.nr_doc }}
                                        </td>
                                        <td>
                                            {{ factura.id?.toString().startsWith('anaf_') 
                                                ? (factura.f_denumire?.match(/cif_emitent=(\d+)/)?.[1] || '-') 
                                                : (factura.f_denumire || '/') 
                                            }}
                                        </td>
                                        <td class="text-end">{{ $filters.toCurrency(factura.intrari_date_valoare) || '0.00' }}</td>
                                        <td class="text-end">{{ $filters.toCurrency(factura.intrari_date_tva) || '0.00' }}</td>
                                        <td class="text-end">{{ $filters.toCurrency(factura.intrari_date_total) || '0.00' }}</td>
                                        
                                        <td>
                                          <div class="progress h-30px">
                                            <div
                                              class="progress-bar progress-bar-striped progress-bar-animated text-white fw-bold fs-6 py-2"
                                              :class="{
                                                'bg-danger': factura.stare === 0 || !factura.stare,
                                                'bg-warning': factura.stare === 1,
                                                'bg-success': factura.stare === 2
                                              }"
                                              role="progressbar"
                                              :style="{
                                                width: factura.stare === 0 || !factura.stare ? '100%' :
                                                       factura.stare === 1 ? '75%' :
                                                       '100%'
                                              }"
                                              :aria-valuenow="factura.stare === 0 || !factura.stare ? 100 :
                                                              factura.stare === 1 ? 75 : 100"
                                              aria-valuemin="0"
                                              aria-valuemax="100"
                                            >
                                              {{ factura.stare === 0 || !factura.stare ? 'Restant' :
                                                 factura.stare === 1 ? 'Parțial' :
                                                 'Achitat' }}
                                            </div>
                                          </div>
                                        </td>
                                        <td class="text-end">{{ $filters.toCurrency(factura.isf_sold) || '0.00' }}</td>
                                        <td>{{ $filters.formatDate(factura.data_scadenta) || '/' }}</td>
                                        <td>
                                          <template v-if="factura.efactura == 1">
                                            <span>Da</span>
                                            <button
                                              class="btn btn-sm btn-light-success ms-2"
                                              type="button"
                                              @click="descarcaFacturaAnaf(factura.id_descarcare, factura.id_firma)"
                                              title="Descarcă e-Factura"
                                            >
                                              <i class="fas fa-download"></i>
                                            </button>
                                          </template>

                                          <template v-else>
                                            <span>Nu</span>
                                            <button
                                              class="btn btn-sm btn-light-warning ms-2"
                                              type="button"
                                              @click="editeazaFactura(factura)"
                                              title="Editează factura"
                                            >
                                              <i class="fas fa-pen"></i>
                                            </button>
                                          </template>
                                        </td>
                                      </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Formular Adaugă Factura (always mounted below container) -->

    
</div>
<div class="row" v-if="!this.$gate.areFirmaSelectata()">
    <div class="card-body p-9" >
        <div class="notice d-flex bg-light-danger rounded border-warning border border-dashed p-6">
            <i class="ki-duotone ki-information fs-2tx text-danger me-4">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
            </i>
            <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-semibold">
                    <h4 class="text-gray-900 fw-bold">Nu aveti o firma selectata</h4>
                    <div class="fs-6 text-gray-700">In cazul in care aveti o firma deja adaugata, trebuie sa selectati firma folosind butonul "Schimba firma" aflat in partea de sus.<br/>
                        In cazul in care nu aveti nicio firma adaugata, trebuie sa adaugati o firma noua pentru a putea utiliza modulul de facturare.
                    </div>
                </div>
                <div class="d-flex align-items-center gap-2 gap-lg-3">
                    <router-link to="/firmele-mele" class="btn btn-sm fw-bold btn-success">
                        Adaugă firmă
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
    
    import moment from "moment";
    import draggable from 'vuedraggable';
    import { createApp } from 'vue';
    import FacturaChild from './Intrari_FacturaChild.vue';
    import AdaugaFactura_Intrare from './AdaugaFactura.vue';
    
    export default {
          components: {
            moment: moment, 
            draggable,
            AdaugaFactura_Intrare
          },
    data () {
        return {
            setari_select2: {
                theme: "bootstrap",
                placeholder: "Selectează din listă",
                width: "100%",
            },
            clienti: [],
            editmode: false,
            facturi_intrare: [],
            afiseazaInformatii: false,
            afiseazaFormularFactura: false,
            afiseazaTabel: true,
            expandedRows: [],
            produseFacturi: {},
            editModeFactura: false,
            facturaDeEditat: null,
        }
    },
    
    methods:{
        descarcaFacturaAnaf: function (id_factura, id_firma) {
            const url = `/api/anaf/iaPDFFactura/${id_factura}/${id_firma}`;
            window.open(url, "_blank");
        },
        extrageDateXML() {
            axios.get('/api/anaf/eXML/6') // id firma = 6
              .then(response => {
                if (response.data.status === 'ok') {
                  Swal.fire({ icon: 'success', title: 'Succes!', text: 'Datele au fost extrase în: ' + (response.data.fisier || '-') });
                } else {
                  Swal.fire({ icon: 'error', title: 'Eroare!', text: response.data.mesaj || 'A apărut o eroare.' });
                }
              })
              .catch(error => {
                console.error('Eroare la extragerea datelor XML:', error);
                Swal.fire({ icon: 'error', title: 'Eroare!', text: 'Eroare la extragerea datelor XML' });
              });
        },
        importaDateEFactura() {
          axios
            .get('/api/anaf/importaEFactura') // id firma = 6
            .then(({ data }) => {
              const status = (data?.status || '').toString().toLowerCase();

              if (status === 'success' || status === 'partial_success') {
                const imported = Number(data?.imported || 0);
                const skipped = Number(data?.skipped_existing || 0);
                const errorsCount = Number(data?.errors_count || 0);
                const total = Number(data?.total_files || 0);

                const baseMsg = data?.message || `Import finalizat. Importate: ${imported}, existente: ${skipped}, erori: ${errorsCount}${total ? ` din total ${total}` : ''}.`;

                // Build optional HTML list for first few errors
                let html = '';
                if (errorsCount > 0 && Array.isArray(data?.errors) && data.errors.length) {
                  const items = data.errors.slice(0, 5).map(e => `<li><code>${(e.file || '-')}</code>: ${(e.error || 'Eroare necunoscută')}</li>`).join('');
                  html = `<p class="mb-2">${baseMsg}</p><p class="mb-1">Erori (primele ${Math.min(5, data.errors.length)}):</p><ul class="text-start" style="max-height:180px;overflow:auto;">${items}</ul>`;
                }

                // Choose icon/title based on completeness
                const isFullSuccess = status === 'success' && errorsCount === 0;
                Swal.fire({
                  icon: isFullSuccess ? 'success' : 'warning',
                  title: isFullSuccess ? 'Succes!' : 'Import parțial',
                  ...(html ? { html } : { text: baseMsg }),
                });
              } else {
                const errText = data?.message || data?.mesaj || 'A apărut o eroare la import.';
                Swal.fire({ icon: 'error', title: 'Eroare!', text: errText });
              }
            })
            .catch((error) => {
              console.error('Eroare la importul eFactura:', error);
              const errText = error?.response?.data?.mesaj || error?.response?.data?.message || 'Eroare la import.';
              Swal.fire({ icon: 'error', title: 'Eroare!', text: errText });
            });
        },
        async descarcaUltimeleFacturi() {
          this.$Progress.start();
          try {
            const response = await axios.get(`/api/anaf/descarca-ultimele-facturi`);
            const data = response?.data || {};
            const status = (data.status || '').toLowerCase();
            const noi = Number(data.new_invoices || 0);
            const total = Number(data.total_messages || 0);
            const errCount = Number(data.errors_count || 0);

            if (status === 'success' || status === 'partial_success') {
              const baseMsg = noi > 0
                ? `Au fost descărcate ${noi} facturi noi${total ? ` din ${total}` : ''}.`
                : 'Nu sunt facturi noi de descărcat.';

              if (errCount > 0 && Array.isArray(data.errors)) {
                const items = data.errors.slice(0, 5)
                  .map(e => `<li>ID ANAF <code>${e.id_anaf ?? '-'}</code> — ${e.stage ?? 'unknown'}: ${e.message ?? 'Eroare'}</li>`) 
                  .join('');
                const html = `<p class=\"mb-2\">${baseMsg}</p>` +
                             `<p class=\"mb-1\">Erori (primele ${Math.min(5, data.errors.length)}):</p>` +
                             `<ul class=\"text-start\" style=\"max-height:180px;overflow:auto;\">${items}</ul>`;
                Swal.fire({ icon: 'warning', title: 'Descărcare parțială', html });
              } else {
                Swal.fire({ icon: noi > 0 ? 'success' : 'info', title: noi > 0 ? 'Succes!' : 'Info', text: baseMsg });
              }
              this.$Progress.finish();
            } else {
              Swal.fire({ icon: 'error', title: 'Eroare!', text: data.message || 'Eroare la descărcare.' });
              this.$Progress.fail();
            }
          } catch (error) {
            console.error(error);
            Swal.fire({ icon: 'error', title: 'Eroare!', text: 'A apărut o eroare.' });
            this.$Progress.fail();
          }
        },
        preiaFacturiAnaf() {
            axios.get('/api/anaf/facturi')
                .then((response) => {
                    if (response.data.status === 'ok') {
                        const facturi = response.data.mesaje.filter(m => m.tip === 'FACTURA PRIMITA');
                        const mapped = facturi.map(f => ({
                            id: `anaf_${f.id}`,
                            data_doc: moment(f.data_creare, "YYYYMMDDHHmm").format("YYYY-MM-DD"),
                            nr_doc: f.id_solicitare,
                            sd_serie: '',
                            c_denumire: f.detalii,
                            iesiri_date_valoare: 0,
                            iesiri_date_tva: 0,
                            iesiri_date_total: 0,
                            stare: null,
                            isf_sold: 0,
                            data_scadenta: null,
                            tva_incasare: false,
                            efactura: true,
                            agent: 'ANAF',
                            cont_debit: ''
                        }));
                        this.facturi_intrare.unshift(...mapped);
                    } else {
                        toast.fire({
                            icon: 'error',
                            title: 'Răspuns ANAF invalid'
                        });
                    }
                })
                .catch((error) => {
                    console.error('Eroare la preluarea facturilor de la ANAF:', error);
                    toast.fire({
                        icon: 'error',
                        title: 'Eroare la preluarea datelor ANAF'
                    });
                });
        },
        produsePeFactura(id) {
            return this.produseFacturi[id] || [];
        },
        formatFacturaChildRow(factura, produse) {
            const wrapper = document.createElement('div');
            const app = createApp(FacturaChild, { factura, produse });
            app.mount(wrapper);
            return wrapper;
        },
        async incarcaProduseFactura(id) {
            try {
                const response = await axios.get('/api/facturare/intrari/incarcaProduseIntrare/' + id);
                this.produseFacturi = {
                  ...this.produseFacturi,
                  [id]: response.data
                };
                // poți salva datele într-un obiect separat dacă vrei
                // this.produseFacturiNou = { ...this.produseFacturiNou, [id]: response.data };
            } catch (error) {
                console.error(`Eroare la încărcarea produselor pentru factura ${id}:`, error);
            }
        },
        incarcaTabelIntrari(){
            axios.get("/api/facturare/intrari/incarcaFacturiIntrare")
            .then((response) => {
                this.facturi_intrare = response.data || [];

                this.$nextTick(() => {
                    // distrugem DataTable vechi dacă există
                    if ($.fn.DataTable.isDataTable('#tabel_facturare')) {
                        $('#tabel_facturare').DataTable().destroy();
                    }

                    $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
                        if (!date) return 0;
                        const parts = date.split('.');
                        return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`); // YYYY-MM-DD
                    };

                    const vm = this;
                    $('#tabel_facturare').DataTable({
                        pageLength: 15,
                        lengthChange: false,
                        columnDefs: [
                            {
                                targets: 0,               // coloana ID ascunsă (numeric)
                                visible: false,
                                searchable: false,
                                type: 'num'
                            },
                            {
                                targets: 1,               // coloana cu butonul de detalii
                                responsivePriority: 1
                            },
                            {
                                targets: 2,               // coloana "Data"
                                type: 'date-eu'
                            }
                        ],
                        order: [[0, 'desc']], // sortare primară după ID desc
                        buttons: ['disable'],
                        language: {
                            url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                        },
                        paging: true,
                        ordering: true,
                        info: true,
                        searching: true,
                        responsive: false,
                        createdRow: function (row, data, dataIndex) {
                            const factura = vm.facturi_intrare[dataIndex];
                            if (factura && factura.id) {
                                $(row).addClass(`row-factura-${factura.id}`);
                            } else {
                                console.warn('Factura ID not found for dataIndex:', dataIndex, data);
                            }
                        }
                    });
                });
            });
        },
        toggleFacturaDetails(factura) {
            const table = $('#tabel_facturare').DataTable();
            const tr = $(`.row-factura-${factura.id}`);
            const row = table.row(tr);

            if (row.child.isShown()) {
              row.child.hide();
              tr.removeClass('shown');
              this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
            } else {
              if (!this.produseFacturi[factura.id]) {
                this.incarcaProduseFactura(factura.id).then(() => {
                  const produse = this.produseFacturi[factura.id] || [];
                  row.child(this.formatFacturaChildRow(factura, produse)).show();
                  tr.addClass('shown');
                  if (!this.expandedRows.includes(factura.id)) {
                    this.expandedRows.push(factura.id);
                  }
                });
              } else {
                const produse = this.produseFacturi[factura.id] || [];
                row.child(this.formatFacturaChildRow(factura, produse)).show();
                tr.addClass('shown');
                if (!this.expandedRows.includes(factura.id)) {
                  this.expandedRows.push(factura.id);
                }
              }
            }
        },
        handleRenuntaFactura() {
            this.afiseazaFormularFactura = false;
            this.afiseazaTabel = true;
            //this.incarcaTabelIntrari(); // dacă vrei să reîncarci și datele
        },
        async editeazaFactura(factura) {
            // open form in edit mode
            this.editModeFactura = true;

            // ANAF rows don't have local products to edit in the same way
            if (!factura || !factura.id || factura.id?.toString().startsWith('anaf_')) {
                this.facturaDeEditat = factura ? JSON.parse(JSON.stringify(factura)) : null;
                this.afiseazaFormularFactura = true;
                this.afiseazaTabel = true;
                return;
            }

            const facturaId = factura.id;

            // Ensure products are loaded (same route used for the details child)
            try {
                await this.incarcaProduseFactura(facturaId);
            } catch (e) {
                console.error('Eroare la încărcarea produselor pentru editare:', e);
            }

            const produse = this.produseFacturi?.[facturaId] || [];

            // clone to avoid accidental mutations from child
            const facturaClone = factura ? JSON.parse(JSON.stringify(factura)) : null;
            if (facturaClone) {
                // pass products to the edit form so it can hydrate its product rows
                facturaClone.produse = JSON.parse(JSON.stringify(produse));
            }

            this.facturaDeEditat = facturaClone;
            this.afiseazaFormularFactura = true;
            this.afiseazaTabel = true;
        },
        handleFacturaSaved() {
            // after add/update, go back to list and refresh
            this.editModeFactura = false;
            this.facturaDeEditat = null;
            this.afiseazaFormularFactura = false;
            this.afiseazaTabel = true;

            if ($.fn.DataTable.isDataTable('#tabel_facturare')) {
                $('#tabel_facturare').DataTable().destroy();
            }
            this.incarcaTabelIntrari();
        },
        adaugaRandProdusDacaETGol() {
            // Add a new row if EITHER 'tip' OR 'denumire' from last row is filled, and only one empty row at the end is allowed.
            const produse = this.facturaProduse;
            if (produse.length === 0) return;

            // Helper: a row is empty if all fields except 'pozitie' are blank/null/undefined
            function isRowEmpty(row) {
                return Object.entries(row).every(([key, val]) =>
                    key === 'pozitie' || val === '' || val === null || val === undefined
                );
            }

            // Count how many empty rows are at the end
            let emptyRowsAtEnd = 0;
            for (let i = produse.length - 1; i >= 0; i--) {
                if (isRowEmpty(produse[i])) {
                    emptyRowsAtEnd++;
                } else {
                    break;
                }
            }

            // Get last row
            const last = produse[produse.length - 1];
            // If EITHER 'tip' OR 'denumire' is filled in last row and no empty row at end, add one
            if (
                (
                    (last.tip && last.tip !== '') ||
                    (last.denumire && last.denumire !== '')
                ) &&
                emptyRowsAtEnd === 0
            ) {
                this.facturaProduse.push({
                    pozitie: produse.length + 1,
                    tip: '',
                    denumire: '',
                    um: '',
                    tva: '',
                    cantitate: '',
                    pret: '',
                    valoare: '',
                    valoare_tva: '',
                    total: '',
                    cont_credit: ''
                });
                    emptyRowsAtEnd = 1; // just added one
            }

            // Keep only one empty row at end (if more, remove extras)
            if (emptyRowsAtEnd > 1) {
                this.facturaProduse.splice(-1, emptyRowsAtEnd - 1);
            }
        },
        modalAdaugareClient(){
            this.editmode = false;
            this.form.reset();
            $('#ClientModal').modal('show');
        },
        modalEditareClient(id){
            this.editmode = true;
            this.form.reset();
            this.form.fill(id);
            if(this.form.activ == 1)
            {
                this.form.activ = true;
            }
            if(this.form.reseller == 1)
            {
                this.form.reseller = true;
            }
            if(this.form.newsletter == 1)
            {
                this.form.newsletter = true;
            }
            if(this.form.is_email_verified == 1)
            {
                this.form.is_email_verified = true;
            }
            $('#ClientModal').modal('show');
        },
        adaugaClient(){
            this.$Progress.start();
            this.form.post('/api/administrare/clienti')
            .then((response)=>{
                toast.fire({
                    type: 'success',
                    icon: 'success',
                    title: 'Client adaugat!'
                })
                emitter.emit('AfterCreate');
                this.$Progress.finish();
            })
            .catch(()=>{
                this.$Progress.fail()
                toast.fire({
                    type: 'warning',
                    icon: 'warning',
                    title: 'Eroare la adăugarea clientului!'
                })
            })
        },
        actualizeazaClient(){
            this.$Progress.start();
            this.form.put('/api/administrare/clienti/'+this.form.id)
            .then(()=>{ //succes
                //$('#ClientModal').modal('hide');
                swal.fire({
                    type: 'success',
                    icon: 'success',
                    title: 'Client actualizat!',
                })
                emitter.emit('AfterCreate');
                this.$Progress.finish();
            })
            .catch(()=>{//fail
                this.$Progress.fail();
                toast.fire({
                    type: 'warning',
                    icon: 'warning',
                    title: 'Eroare la actualizarea clientului!'
                })
            });
        },
        reindexPozitii() {
          this.facturaProduse.forEach((p, i) => {
            p.pozitie = i + 1;
          });
        },
        handleFullArrowNavigation(event) {
            const selectors = '#formular input, #formular select, #formular textarea, #formular_rapid input, #formular_rapid select, #formular_rapid textarea';
            const inputs = Array.from(document.querySelectorAll(selectors)).filter(
                el => !el.disabled && el.offsetParent !== null
            );

            const index = inputs.indexOf(event.target);
            if (index === -1) return;

            // Detect .row-based layout for responsive facturaProduse
            const rowEl = event.target.closest('.row');
            let currentRowIndex = -1;
            let currentColIndex = -1;
            let rows = [];
            let usingRowLayout = false;

            if (rowEl) {
                // Find all sibling .row elements inside the same parent (the responsive container)
                rows = Array.from(rowEl.parentElement.querySelectorAll('.row')).filter(
                    row => row.querySelector('input, select, textarea')
                );
                for (let i = 0; i < rows.length; i++) {
                    const cols = Array.from(rows[i].querySelectorAll('input, select, textarea')).filter(
                        el => !el.disabled && el.offsetParent !== null
                    );
                    const colIndex = cols.indexOf(event.target);
                    if (colIndex !== -1) {
                        currentRowIndex = i;
                        currentColIndex = colIndex;
                        usingRowLayout = true;
                        break;
                    }
                }
            }

            // Fallback to table-based navigation if not in .row
            let table = null;
            let tableRows = [];
            let tableRowIdx = -1;
            let tableColIdx = -1;
            if (!usingRowLayout) {
                table = event.target.closest('table');
                if (table) {
                    tableRows = Array.from(table.querySelectorAll('tbody tr'));
                    for (let i = 0; i < tableRows.length; i++) {
                        const cols = Array.from(tableRows[i].querySelectorAll('input, select, textarea')).filter(
                            el => !el.disabled && el.offsetParent !== null
                        );
                        const colIndex = cols.indexOf(event.target);
                        if (colIndex !== -1) {
                            tableRowIdx = i;
                            tableColIdx = colIndex;
                            break;
                        }
                    }
                }
            }

            let next = null;
            const isNumberInput = event.target.tagName === 'INPUT' && event.target.type === 'number';
            switch (event.key) {
                case 'ArrowRight':
                    // Always move horizontally regardless of layout, even for number input
                    next = inputs[index + 1];
                    break;
                case 'ArrowLeft':
                    // Always move horizontally regardless of layout, even for number input
                    next = inputs[index - 1];
                    break;
                case 'ArrowDown':
                case 'ArrowUp':
                    if (isNumberInput) {
                        event.preventDefault();
                    }
                    // Responsive .row layout navigation
                    if (usingRowLayout && currentRowIndex !== -1 && currentColIndex !== -1) {
                        if (event.key === 'ArrowDown' && currentRowIndex < rows.length - 1) {
                            const nextRowInputs = Array.from(rows[currentRowIndex + 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = nextRowInputs[currentColIndex] || null;
                        }
                        if (event.key === 'ArrowUp' && currentRowIndex > 0) {
                            const prevRowInputs = Array.from(rows[currentRowIndex - 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = prevRowInputs[currentColIndex] || null;
                        }
                    }
                    // Table navigation fallback
                    if (!usingRowLayout && table && tableRowIdx !== -1 && tableColIdx !== -1) {
                        if (event.key === 'ArrowDown' && tableRowIdx < tableRows.length - 1) {
                            const nextRowInputs = Array.from(tableRows[tableRowIdx + 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = nextRowInputs[tableColIdx] || null;
                        }
                        if (event.key === 'ArrowUp' && tableRowIdx > 0) {
                            const prevRowInputs = Array.from(tableRows[tableRowIdx - 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = prevRowInputs[tableColIdx] || null;
                        }
                    }
                    break;
            }

            if (next) {
                event.preventDefault();
                next.focus();
            }
        },
    },
    computed: {
        expandedFacturi() {
            return this.facturi_intrare.filter(factura => this.expandedRows.includes(factura.id));
        }
    },
    created(){
        //console.log(this.$gate.firma_curenta); // ar trebui să fie null dacă nu e setată
        //console.log(this.$gate.areFirmaSelectata()); // trebuie să fie false dacă firma_curenta e null
        emitter.on('searching',() => {//search
            let query = this.$parent.search;
            axios.get('/api/utile/cautareDosare?cD=' + query)
            .then((data)=>{
                this.dosare =data.data
            })
            .catch(()=>{
                console.log('eroare la cautare');
            })
        })
        this.incarcaTabelIntrari();
        emitter.on('AfterCreate',() => { 
            if ($.fn.DataTable.isDataTable('#tabel_facturare')) {
                $('#tabel_facturare').DataTable().destroy();
            }
            this.incarcaTabelIntrari();
        });
    },
    
    }
    </script>
    
    
<style lang="scss" scoped>


    .icon-mare {
        font-size: 24px
    }

    #tabel_facturare {
        font-size: 14px;
    }

    #tabel_facturare th,
    #tabel_facturare td {
        padding: 4px 6px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .fas {
        transition: transform 0.3s ease;
    }

    .rotate-up {
        transform: rotate(180deg);
    }
    .rotate-down {
        transform: rotate(0deg);
    }

    #tabel_facturare tbody tr {
        border-bottom: 2px solid #bdbdbd;
    }

    #tabel_facturare tbody tr:not(.child):hover {
        background-color: #d4f8dd !important;
    }

    #tabel_facturare tbody tr.shown {
        background-color: #e0ffe0 !important; /* Verde deschis sau orice vrei */
    }

</style>
        